/**
 * Format a Date to 'YYYY-MM-DD' string used as date keys across recall report.
 */
export function toDateKey(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/**
 * Format a Date to 'YYYY-MM-DD' using its UTC components. Inventory snapshots are
 * stamped (and scheduled) in UTC on the backend — notably the evening snapshot at
 * 22:00 UTC — so the Statement picker must bucket them by UTC day. Local bucketing
 * shifts that 22:00-UTC snapshot onto the next calendar day for viewers east of UTC
 * (LR-485).
 */
export function toUtcDateKey(d: Date): string {
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}
